export class Tyre {
    id: number;
    fleet_id: number; 
    driver_id: number;
    provider_id: number;
    tyre_description: string;
    cost: number;
    date_done: string;
    time_done: string;
    time_string: TimeString;
    mileage: string;
    fault: string;
    receipt_no: string;
    note: string;
    file: string; 
    hours: number;
    ///////////////////
    driver: string;
    provider: string;
    rego: string
    user: string; //user display name for logging

}

export interface TimeString {
    hour: number;
    minute: number;
}

